import i18next from 'i18next'
import getUserLanguage from 'src/utils/getUserLanguage'
import { REGEX } from 'www/utils/regex'

/**
 * @description
 *
 * Функция возвращает объект для валидации поля "password"
 *
 * @returns {object} - объект функций с валидацией поля по различным параметрам. Каждая функция принимает обязательное значение поля - value
 */

const PASSWORD_LENGTH = {
  max: 32,
  min: 8,
}

const options = { ns: getUserLanguage() }

function getPasswordValidation() {
  return {
    required: val => !!val || i18next.t('Введите пароль', options),
    minLength: val => val.length >= PASSWORD_LENGTH.min || i18next.t('От {count} символов', { ...options, count: PASSWORD_LENGTH.min }),
    maxLength: val => val.length <= PASSWORD_LENGTH.max || i18next.t('Должно быть не больше {count} символов', { ...options, count: PASSWORD_LENGTH.max }),
    onlyLettersAndDigits: val => (
      /[A-Z]/.test(val) && /\d/.test(val) && !REGEX.invalidPassword.test(val)
    ) || i18next.t('От {count} символов с хотя бы одной цифрой и одной заглавной буквой, только латиница', { ...options, count: PASSWORD_LENGTH.min }),
  }
}

export default getPasswordValidation
